import { PawPrint } from "lucide-react";

// Tasteful paw-print divider used between major sections.
export default function PawDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-3 py-2 ${className}`} aria-hidden="true">
      <span className="h-px w-16 bg-border sm:w-24" />
      <PawPrint className="h-4 w-4 text-gold rotate-[-12deg]" strokeWidth={2} />
      <PawPrint className="h-5 w-5 text-gold-dark" strokeWidth={2} />
      <PawPrint className="h-4 w-4 text-gold rotate-[12deg]" strokeWidth={2} />
      <span className="h-px w-16 bg-border sm:w-24" />
    </div>
  );
}
